<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useAutonodeStore } from '@/stores/waitingAutonode.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import { useNodeStore } from '@/stores/node.store';
import _ from 'lodash';
import Multiselect from 'vue-multiselect';

const autonodeStore = useAutonodeStore();
const projectStore = useProjectStore();
const nodeStore = useNodeStore();
const { direction_values, selectedDirectionIndex } = storeToRefs(autonodeStore);
const { project } = storeToRefs(projectStore);
const { bpNode } = storeToRefs(nodeStore);
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const conditionValue = ref('');
const direction_ids = ref(null);

const directionOptions = computed(() => bpNode.value.child_directions?.map(d => d.id) || []);

const isNodeTypeSome = bpNode.value.current.node.direction_type === 'some';

function getTitle(id) {
  return bpNode.value.child_directions?.find(d => d.id === id)?.next_bp_node?.current?.node?.name;
}

function createOutput() {
  if (selectedDirectionIndex.value in direction_values.value) {
    direction_values.value = _.omit(direction_values.value, selectedDirectionIndex.value);
  }

  direction_values.value[conditionValue.value] = direction_ids.value;
  closeModal();
}
onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (selectedDirectionIndex.value in direction_values.value) {
    conditionValue.value = selectedDirectionIndex.value;
    direction_ids.value = direction_values.value[selectedDirectionIndex.value];
  }
});
</script>

<template>
  <ModalTemplateSide @submit="createOutput">
    <template v-slot:title>Добавить выходные данные</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Сравниваемое значение</label>
        <input type="text" class="form-control" v-model="conditionValue">
      </div>
      <div class="mt-3">
        <label class="form-label">Направление</label>
        <Multiselect
          v-model="direction_ids"
          :options="directionOptions"
          placeholder="Выбрать..."
          :multiple="isNodeTypeSome"
          :custom-label="getTitle"
          class="multiselect-style"
        />
      </div>
    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
